var map = {
	"./score0.png": 7033,
	"./score1.png": 7136,
	"./score2.png": 8427,
	"./score3.png": 7298,
	"./score4.png": 5197,
	"./score5.png": 8516,
	"./score6.png": 3007,
	"./score7.png": 3990,
	"./score8.png": 9185,
	"./score9.png": 8056,
	"./scoreboard.png": 3637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7538;